import { Box } from '@mui/material';
import augmentLogo from '@assets/augment-logo.svg';
import headerLeft from '@assets/header-left.svg';

export const Header = () => {
  return (
    <Box
      sx={{
        height: { xs: '2.5rem', sm: '4.875rem' },
        backgroundColor: 'var(--background)',
        alignItems: 'center',
        paddingX: { xs: '0.5rem', sm: '1.25rem' },
        display: 'flex',
        justifyContent: 'space-between'
      }}
    >
      <Box
        component="img"
        src={headerLeft}
        alt="How Now Embedded App"
      />

      <Box
        component="img"
        src={augmentLogo}
        alt="AI Augment"
        sx={{ display: 'block', width: { xs: '2rem', sm: '3rem' } }}
      />
    </Box>
  );
};
